import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import useForm from 'react-hook-form';
import Modal from 'react-responsive-modal';
import GoogleMapReact from 'google-map-react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { useStateValue } from '../../store';
import Breadcrumb from '../common/breadcrumb';
import api from '../../config/axios';
import Loader from '../common/loader';
import { date, time } from '../../utils/date';
import ModalSubscription from './common/modal-subscription';

export const renderTextPedido = (purchase) => {
    let text = '';
    if (purchase.quantity > 0) {
        text = `${purchase.quantity} recarga${purchase.quantity > 1 ? 's' : ''}`;
        if (
            purchase.quantity_new_bottles +
            purchase.quantity_starterkit +
            purchase.quantity_dispenser >
            0
        ) {
            text = text + ' y otros...';
        }
        return text;
    } else {
        if (purchase.quantity_starterkit > 0) {
            text = `${purchase.quantity_starterkit} kit de inicio`;
            if (purchase.quantity_new_bottles + purchase.quantity_dispenser > 0) {
                text = text + ' y otros...';
            }
            return text;
        }

        if (purchase.quantity_new_bottles > 0) {
            text = `${purchase.quantity_new_bottles} botellon nuevo`;
            if (purchase.quantity_dispenser > 0) {
                text = text + ' y otros...';
            }
            return text;
        }

        if (purchase.quantity_dispenser > 0) {
            text = `${purchase.quantity_dispenser} dispensador${purchase.quantity_dispenser > 1 ? 'es' : ''
                }`;
            return text;
        }
        return text;
    }
};

const ClientDetail = withRouter((props) => {
    const { handleSubmit, register, errors, setValue, clearError, getValues, watch } = useForm();
    const {
        handleSubmit: handleSubmitPush,
        register: registerPush,
        errors: errorsPush,
    } = useForm();
    const {
        handleSubmit: handleSubmitClient,
        register: registerClient,
        errors: errorsClient,
    } = useForm();
    const {
        handleSubmit: handleSubmitLegal,
        register: registerLegal,
        errors: errorsLegal,
    } = useForm();
    const [{ auth }] = useStateValue();
    const { history } = props;
    const clientId = props.match.params.id;
    const isDelivery = auth.user.role === 'DELIVERY';

    const [loaded, setLoaded] = useState(false);
    const [client, setClient] = useState([]);
    const [settings, setSettings] = useState(null);
    const [modalAddress, setModalAddress] = useState({
        data: null,
        visible: false,
    });
    const [modalDeleteAddress, setModalDeleteAddress] = useState({
        data: null,
        visible: false,
    });
    const [modalDefaultAddress, setModalDefaultAddress] = useState({
        data: null,
        visible: false,
    });
    const [modalSubscription, setModalSubscription] = useState({
        data: null,
        visible: false,
    });
    const [modalCorreo, setModalCorreo] = useState(false);
    const [modalLegalInformation, setModalLegalInformation] = useState(false);
    const [updateClient, setUpdateClient] = useState(false);
    const [map, setMap] = useState(null);

    useEffect(() => {
        //register({ name: 'location' }, { required: true });
        Promise.all([fetchSettings(), fetchClientInfo()]).then((values) => {
            setSettings(values[0]);
            setLoaded(true);
        });
    }, []);

    useEffect(() => {
        if (loaded && client.addresses.length > 0) {
            client.addresses.map((address, index) => {
                let map = new window.google.maps.Map(document.getElementById(`map-${index}`), {
                    center: { lat: address.latitude, lng: address.longitude },
                    zoom: 17,
                    mapTypeControl: false,
                    streetViewControl: false,
                });
                new window.google.maps.Marker({
                    position: { lat: address.latitude, lng: address.longitude },
                    map,
                });
            });
        }
    }, [loaded]);

    useEffect(() => {
        if (modalAddress.visible) {
            let coordinates = null;

            // Ask for geolocation permit
            navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
                if (result.state === 'granted') {
                    if (modalAddress.data) {
                        initGoogleMap(
                            modalAddress.data.latitude,
                            modalAddress.data.longitude,
                        );
                    } else {
                        initGoogleMap(
                            7.767845,
                            -72.221952,
                            15
                        );
                    }
                } else if (result.state === 'prompt') {
                    if (modalAddress.data) {
                        initGoogleMap(
                            modalAddress.data.latitude,
                            modalAddress.data.longitude,
                        );
                    } else {
                        initGoogleMap(
                            7.767845,
                            -72.221952,
                            15
                        );
                    }
                } else {
                    initGoogleMap(
                        modalAddress.data.latitude,
                        modalAddress.data.longitude,
                    );
                }
            });

        }
    }, [modalAddress]);

    const initGoogleMap = (lat, lng, zoom = 16) => {
        let map = new window.google.maps.Map(document.getElementById(`map`), {
            center: {
                lat,
                lng,
            },
            zoom,
            mapTypeControl: false,
            streetViewControl: false,
        });
        const marker = new window.google.maps.Marker({
            position: {
                lat,
                lng,
            },
            map,
        });

        map.addListener('center_changed', () => {
            var newLatLng = new window.google.maps.LatLng(map.center.lat(), map.center.lng());

            marker.setPosition(newLatLng);
        });
        setMap(map);
    };

    const fetchSettings = async () => {
        const { data } = await api.get(`/settings`);
        const settings = data.data[0];

        return settings;
    };

    const fetchClientInfo = async () => {
        const clientRequest = api.get(`/client/${clientId}`);
        const addressesRequest = api.get(`/client/${clientId}/address`);
        const purchasesRequest = api.get(`/client/${clientId}/purchase`);
        const clubRequest = api.get(`/client/${clientId}/club`);
        const clienSubscription = api.get(`/client/${clientId}/subscription`);

        const values = await Promise.all([
            clientRequest,
            addressesRequest,
            purchasesRequest,
            clubRequest,
            clienSubscription,
        ]);

        const client = values[0];
        const addresses = values[1];
        const purchases = values[2];
        const club = values[3];
        const subscription = values[4];

        setClient({
            ...client.data.data,
            subscription: subscription && subscription.data ? subscription.data.data : null,
            addresses: addresses.data.data.rows,
            purchases: purchases.data.data.rows,
            club: club.data.data,
        });
        return;
    };

    const handleApiLoaded = (map, maps) => {
        const triangleCoords = settings.boundary.map((item) => ({
            lat: item.latitude,
            lng: item.longitude,
        }));

        var bermudaTriangle = new maps.Polygon({
            paths: triangleCoords,
            strokeColor: '#00a4d3',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#00a4d3',
            fillOpacity: 0.15,
        });
        bermudaTriangle.setMap(map);
    };

    const handleClientLocation = (data) => {
        setValue('location', null);
        const coordinates = {
            latitude: data.center.lat(),
            longitude: data.center.lng(),
        };
        setValue('location', coordinates);
    };

    const addClientLocation = async (data) => {
        // upload image to s3
        let imageUrl = null;

        if (data.photoBottle.length > 0) {
            imageUrl = await compressAndUpload(data.photoBottle[0], clientId, data.street1);
            imageUrl = imageUrl.replace(
                'https://aguaman-envases-clientes.s3.amazonaws.com/',
                'https://dxot6n0pcppgt.cloudfront.net/',
            );
        }

        if (data.newBottleAguaman) {
            imageUrl = 'https://d25vjkdnn83buj.cloudfront.net/botellon-nuevo-aguaman.jpg';
        }
        const dataAddress = {
            street1: data.street1,
            street2: data.street2,
            house_number: 'N/A',
            latitude: map?.center.lat(),
            longitude: map?.center.lng(),
            longway: data.longway,
            gpsVerified: data.gpsVerified,
            newBottles: data.newBottles || 0,
            observation: data.observation,
            photoBottle: imageUrl,
        };
        api.post(`/client/${clientId}/address`, dataAddress)
            .then(() => {
                toast.info('Dirección agregada con éxito');
                setModalAddress({ visible: false });
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch((error) => {
                toast.error('Hubo un error al agregar la dirección. Intente de nuevo');
            });
    };

    const updateClientLocation = async (data) => {
        // upload image to s3
        let imageUrl = data.photoBottle;

        if (data.photoBottle.length > 0) {
            imageUrl = await compressAndUpload(data.photoBottle[0], clientId, data.street1);
            imageUrl = imageUrl.replace(
                'https://aguaman-envases-clientes.s3.amazonaws.com/',
                'https://dxot6n0pcppgt.cloudfront.net/',
            );
        } else {
            imageUrl = modalAddress.data.photoBottle;
        }

        if (data.newBottleAguaman) {
            imageUrl = 'https://d25vjkdnn83buj.cloudfront.net/botellon-nuevo-aguaman.jpg';
        }
        const dataAddress = {
            street1: data.street1,
            street2: data.street2,
            newBottles: data.newBottles,
            observation: data.observation,
            house_number: 'N/A',
            latitude: map?.center.lat(),
            longitude: map?.center.lng(),
            longway: data.longway,
            photoBottle: imageUrl,
            gpsVerified: data.gpsVerified,
            type: data.type,
            coolingDispenser: data.coolingDispenser,
            publicSite: data.publicSite,
        };

        api.put(`/client/${clientId}/address/${modalAddress.data.id}`, dataAddress)
            .then(() => {
                toast.info('Dirección modificada con éxito');
                setModalAddress({ visible: false });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch((error) => {
                toast.error('Hubo un error al modificar la dirección. Intente de nuevo');
            });
    };

    const deletePhotoBottle = (data) => {
        api.put(`/client/${clientId}/address/${modalAddress.data.id}`, {
            ...data,
            photoBottle: null,
        })
            .then(() => {
                toast.info('Foto del botellón eliminada con éxito');
                setModalAddress({ visible: false });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch(() => {
                toast.error('Hubo un error al eliminar la foto del botellón. Intente de nuevo');
            });
    };

    const updateClientInformation = (data) => {
        const dataInformation = {
            name: data.name,
            phone_number: data.phone_number,
            email: data.email,
        };

        api.put(`/client/${clientId}`, dataInformation)
            .then(() => {
                toast.info('Información del cliente modificada con éxito');
                setUpdateClient(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch((error) => {
                if (error.response.data) {
                    toast.error(error.response.data.errors[0].msg);
                } else {
                    toast.error('Hubo un error. Intenta de nuevo');
                }
            });
    };

    const updateLegalInformation = (data) => {
        const legalInformation = {
            businessName: data.businessName,
            rif: data.rif,
            phoneNumber: data.legalPhoneNumber,
            address: data.legalAddress,
        };

        api.put(`/client/${clientId}/legal-information`, { legalInformation })
            .then(() => {
                toast.info('Información fiscal modificada con éxito');
                setModalLegalInformation(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    toast.error(error.response.data.errors[0].msg);
                } else {
                    toast.error('Hubo un error. Intenta de nuevo');
                }
            });
    };

    const deleteAddress = (id) => {
        api.delete(`/client/${clientId}/address/${id}`)
            .then(() => {
                toast.info('Dirección eliminada con éxito');
                setModalDeleteAddress({ visible: false });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch((error) => {
                if (error.response.data) {
                    toast.error(error.response.data.errors[0].msg);
                } else {
                    toast.error('Hubo un error. Intenta de nuevo');
                }
            });
    };

    const defaultAddress = (id) => {
        api.put(`/client/${clientId}/address-default-admin/${id}`)
            .then(() => {
                toast.info('Dirección por defecto modificada con éxito');
                setModalDefaultAddress({ visible: false });
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
            .catch((error) => {
                if (error.response.data) {
                    toast.error(error.response.data.errors[0].msg);
                } else {
                    toast.error('Hubo un error. Intenta de nuevo');
                }
            });
    };

    const sendPushNotification = (data) => {
        const notificationPush = {
            ...data,
            data: {
                view: data.view || null,
                id: data.viewId || null,
                link: data.link || null,
            },
        };
        api.post(`/client/${clientId}/notification`, notificationPush)
            .then(() => {
                toast.success('Notificatión enviada con éxito');
            })
            .catch((error) => {
                toast.error('Hubo un error al enviar la notificación. Intente de nuevo');
            });
    };

    const sendEmailClientOffline = (email) => {
        api.get(`/client/offline?email=${email}`)
            .then(() => {
                toast.success('Correo enviado con éxito');
                setModalCorreo(false);
            })
            .catch((error) => {
                toast.error('Hubo un error al enviar el correo. Intente de nuevo');
            });
    };

    const renderClientPurchases = () => {
        const multipleAddresses = client.addresses.length > 1;
        return client.purchases.map((item, index) => {
            const fechaPedidoCreado = item.transactions.find(
                (item) => item.name === 'Pedido Creado',
            );
            return (
                <div key={`purchase-client-${index}`}>
                    <div className="d-flex justify-content-between mb-3">
                        <div>
                            <p>
                                <a href={`${process.env.PUBLIC_URL}/recargas/detalle/${item.id}`}>
                                    {item.id}
                                </a>
                            </p>
                            {multipleAddresses && (
                                <p style={{ margin: 0, padding: 0 }}>{item.address.street1}</p>
                            )}
                            <p style={{ margin: 0, color: 'green' }}>{item.couponId && 'Cupón'}</p>
                            <p style={{ margin: 0 }}>{item.paymentMethod.name}</p>
                            <p>
                                <strong>{renderTextPedido(item)}</strong>
                            </p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <p className="mt-0 mb-0">{date(fechaPedidoCreado.createdAt)}</p>
                            <p className="mt-0 mb-0">
                                <strong>{time(fechaPedidoCreado.createdAt)}</strong>
                            </p>
                        </div>
                    </div>
                    <hr />
                </div>
            );
        });
    };

    const compressAndUpload = async (file, clientId, street1) => {
        // Comprimir
        const compressedBlob = await compressImage(file);

        // Convertir Blob a Buffer/ArrayBuffer para S3
        const arrayBuffer = await compressedBlob.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        // Subir a S3
        const imageUrl = await handleImageS3(file, buffer, clientId, street1);
        return imageUrl;
    };

    const compressImage = async (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Redimensionar manteniendo proporción
                const maxWidth = 700;
                const ratio = maxWidth / img.width;
                canvas.width = maxWidth;
                canvas.height = img.height * ratio;

                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                // Comprimir a JPEG
                canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    'image/jpg',
                    0.8,
                );
            };
        });
    };

    /**
     * Handle request of signed URL and upload procces of files to AWS S3
     * @param {Object} data Information about category (name, image, src)
     * @return {String} URL to store in DB
     */
    const handleImageS3 = async (file, buffer, idCliente, nameAddress) => {
        const addressTrimmed = nameAddress.split(' ')[0];
        const fileName = `${idCliente}-${addressTrimmed}.${file.type.split('/')[1]}`;
        const fileType = file.type;
        const requestSigning = {
            fileName,
            fileType,
        };

        // request signedurl to AWS
        const responseAWS = await api.post('/aws/request-url-signed', requestSigning);
        const { signedRequest, url } = responseAWS.data.data;

        // upload image directly to S3 bucket
        try {
            await axios({
                url: signedRequest,
                method: 'PUT',
                data: buffer,
                headers: {
                    'Content-Type': fileType,
                },
            });
            return url;
        } catch (e) {
            console.log(e);
        }
    };

    const handleInputImage = (e) => {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        if (!file) return;
        //const imgs = dummyimgs;

        reader.onloadend = () => {
            // imgs[i].img = reader.result;
            // imgs[i].update = false;
            // setDummyImgs(imgs);
            // setFile(file);
        };
        reader.readAsDataURL(file);
    };

    if (!loaded)
        return (
            <div style={{ display: 'flex', height: '50vh' }}>
                <Loader />
            </div>
        );

    const locationClient = getValues('location');
    const greatPlaceStyle = {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
    };

    const phoneParsed = client.phone_number;
    const whatsappUrl = `https://wa.me/${phoneParsed}`;

    return (
        <Fragment>
            <Breadcrumb title="Detalle de cliente" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <form className="needs-validation user-add" noValidate="">
                                    <div className="form-group row m-0">
                                        <h4 style={{ fontSize: 20 }}>
                                            {client.id} - {client.name} ({client.tokenInvitation})
                                        </h4>
                                    </div>
                                    <div className="form-group row m-0">
                                        <p style={{ color: '#444' }}>
                                            <i className="fa fa-phone"></i> {client.phone_number}
                                        </p>
                                    </div>
                                    <div className="form-group row m-0">
                                        <p style={{ color: '#444' }}>
                                            <i className="fa fa-envelope"></i> {client.email}
                                        </p>
                                    </div>
                                    <hr />
                                    <div className="form-group row m-0">
                                        <p style={{ color: '#444' }}>
                                            <strong>{client.club.points}</strong> puntos -{' '}
                                            {!isDelivery && (
                                                <Link
                                                    to={`${process.env.PUBLIC_URL}/clientes/${client.id}/cupones`}
                                                >
                                                    Ver cupones
                                                </Link>
                                            )}
                                        </p>
                                    </div>
                                    <div className="form-group row m-0">
                                        <p style={{ color: '#444' }}>
                                            <strong>{client.subscription.availability}</strong>{' '}
                                            recargas a favor
                                        </p>
                                    </div>

                                    <div
                                        className="row"
                                        style={{ display: !updateClient ? 'none' : 'block' }}
                                    >
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Nombre
                                            </label>
                                            <input
                                                className="form-control col-xl-8 col-md-7"
                                                defaultValue={client.name}
                                                type="text"
                                                disabled={!updateClient}
                                                name="name"
                                                ref={registerClient({ required: true })}
                                            />
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Email
                                            </label>
                                            <input
                                                className="form-control col-xl-8 col-md-7"
                                                defaultValue={client.email}
                                                type="email"
                                                disabled={!updateClient}
                                                name="email"
                                                ref={registerClient({
                                                    required: true,
                                                    pattern:
                                                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/i,
                                                })}
                                            />
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Teléfono
                                            </label>
                                            <input
                                                className="form-control col-xl-8 col-md-7"
                                                defaultValue={client.phone_number}
                                                type="text"
                                                disabled={!updateClient}
                                                name="phone_number"
                                                ref={registerClient({ required: true })}
                                            />
                                        </div>
                                    </div>

                                    {!isDelivery && (
                                        <div className="form-group row mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-info"
                                                onClick={() => setUpdateClient(!updateClient)}
                                            >
                                                {updateClient ? (
                                                    'Cancelar'
                                                ) : (
                                                    <i className="fa fa-pencil"></i>
                                                )}
                                            </button>
                                            &nbsp;&nbsp;
                                            {updateClient && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={handleSubmitClient(
                                                        updateClientInformation,
                                                    )}
                                                >
                                                    Guardar
                                                </button>
                                            )}
                                            {!updateClient && (
                                                <>
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={() =>
                                                            setModalLegalInformation(true)
                                                        }
                                                    >
                                                        <i className="fa fa-file"></i>
                                                    </button>
                                                    &nbsp;&nbsp;
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        onClick={() => setModalCorreo(true)}
                                                    >
                                                        <i className="fa fa-envelope"></i>
                                                    </button>
                                                    &nbsp;&nbsp;
                                                    <a
                                                        type="button"
                                                        className="btn btn-success"
                                                        href={whatsappUrl}
                                                        target="_blank"
                                                    >
                                                        <i className="fa fa-whatsapp"></i>
                                                    </a>
                                                    &nbsp;&nbsp;
                                                    {client.purchases.length > 0 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() =>
                                                                setModalSubscription({
                                                                    visible: true,
                                                                })
                                                            }
                                                        >
                                                            <i className="fa fa-gift"></i>
                                                        </button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                    <div className="form-group row mt-4">
                                        <Link
                                            to={`${process.env.PUBLIC_URL}/recargas/nueva-recarga?clientId=${client.id}`}
                                            className="btn btn-primary"
                                        >
                                            <i className="fa fa-shopping-cart"></i> Hacer pedido
                                        </Link>
                                    </div>
                                </form>
                                <div className="needs-validation mt-5">
                                    <hr />
                                    <div className="form-group row">
                                        <h4 style={{ color: '#555' }}>
                                            <i className="fa fa-map-marker"></i> Direcciones de
                                            entrega
                                        </h4>
                                    </div>

                                    {client.addresses
                                        .sort((a, b) => b.default - a.default)
                                        .map((address, index) => (
                                            <div
                                                key={`address-${index}`}
                                                className="form-group row"
                                            >
                                                <p
                                                    className="col-xl-12 p-0 m-0"
                                                    style={{ fontSize: 18, color: '#444' }}
                                                >
                                                    <strong>
                                                        {address.gpsVerified && (
                                                            <i className="fa fa-check-circle text-primary"></i>
                                                        )}{' '}
                                                        {address.street1}, {address.street2}
                                                    </strong>
                                                </p>
                                                <p className="col-xl-12 p-0 m-0">
                                                    Botellones nuevos:{' '}
                                                    <strong>{address.newBottles}</strong>
                                                    &nbsp;&nbsp;
                                                    {address.photoBottle && (
                                                        <a
                                                            href={address.photoBottle}
                                                            target="_blank"
                                                        >
                                                            (<strong>Ver Foto</strong>)
                                                        </a>
                                                    )}
                                                </p>
                                                <p className="col-xl-12 p-0 m-0">
                                                    Observación:{' '}
                                                    <strong>{address.observation || 'N/A'}</strong>
                                                </p>
                                                <p className="col-xl-12 p-0 m-0">
                                                    Larga:{' '}
                                                    <strong>{address.longway ? 'Sí' : 'No'}</strong>
                                                </p>
                                                <br />
                                                <div
                                                    className="col-xl-12 p-0 m-0"
                                                    style={{
                                                        width: '100%',
                                                        height: 400,
                                                    }}
                                                >
                                                    <div
                                                        id={`map-${index}`}
                                                        className="col-xl-12"
                                                        style={{ width: '100%', height: 400 }}
                                                    ></div>
                                                </div>
                                                <div className="col-sm-12 text-right mt-1">
                                                    {!address.default && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() =>
                                                                setModalDeleteAddress({
                                                                    visible: true,
                                                                    data: address.id,
                                                                })
                                                            }
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    )}
                                                    &nbsp;&nbsp;
                                                    {!address.default && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-warning"
                                                            onClick={() =>
                                                                setModalDefaultAddress({
                                                                    visible: true,
                                                                    data: address.id,
                                                                })
                                                            }
                                                        >
                                                            <i className="fa fa-check"></i>
                                                        </button>
                                                    )}
                                                    &nbsp;&nbsp;
                                                    <button
                                                        type="submit"
                                                        className="btn btn-info"
                                                        onClick={() =>
                                                            setModalAddress({
                                                                visible: true,
                                                                data: address,
                                                            })
                                                        }
                                                    >
                                                        <i className="fa fa-pencil"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    <div className="col-sm-12 text-center mt-5 mb-3">
                                        <button
                                            type="submit"
                                            className="btn btn-success"
                                            onClick={() => setModalAddress({ visible: true })}
                                        >
                                            Agregar Nueva dirección
                                        </button>
                                    </div>
                                    <Modal
                                        open={modalAddress.visible}
                                        center
                                        classNames={{ modal: 'modal-update-address' }}
                                        onClose={() => setModalAddress({ visible: false })}
                                    >
                                        <div className="modal-header">
                                            <h5 className="modal-title f-w-600">
                                                Agregar dirección
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row product-adding">
                                                <div className="col-xl-10 offset-xl-1">
                                                    <div className="needs-validation add-product-form">
                                                        <div className="form form-label-center">
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-12">
                                                                    <input
                                                                        type="street1"
                                                                        className="form-control"
                                                                        placeholder="Ingresa avenida, calle, carrera, vereda"
                                                                        name="street1"
                                                                        defaultValue={
                                                                            modalAddress.data &&
                                                                            modalAddress.data
                                                                                .street1
                                                                        }
                                                                        ref={register({
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                    {errors.street1 &&
                                                                        errors.street1.type ===
                                                                        'required' && (
                                                                            <p className="message-error-input">
                                                                                Dirección
                                                                                obligatoria
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <input
                                                                        type="street2"
                                                                        className="form-control"
                                                                        placeholder="Ingrese número de casa, piso y/o apto"
                                                                        name="street2"
                                                                        defaultValue={
                                                                            modalAddress.data &&
                                                                            modalAddress.data
                                                                                .street2
                                                                        }
                                                                        ref={register({
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                    {errors.street2 &&
                                                                        errors.street2.type ===
                                                                        'required' && (
                                                                            <p className="message-error-input">
                                                                                Este campo es
                                                                                obligatorio
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        placeholder="Cantidad botellones nuevos"
                                                                        name="newBottles"
                                                                        defaultValue={
                                                                            modalAddress.data &&
                                                                            modalAddress.data
                                                                                .newBottles
                                                                        }
                                                                        ref={register({
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                    {errors.newBottles &&
                                                                        errors.newBottles.type ===
                                                                        'required' && (
                                                                            <p className="message-error-input">
                                                                                Este campo es
                                                                                obligatorio
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Tipo de envase. Información importante de la dirección"
                                                                        name="observation"
                                                                        defaultValue={
                                                                            modalAddress.data &&
                                                                            modalAddress.data
                                                                                .observation
                                                                        }
                                                                        ref={register({
                                                                            required: false,
                                                                        })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="radio"
                                                                            className="form-control"
                                                                            id="typeCasa"
                                                                            name="type"
                                                                            value="casa"
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .type === 'casa'
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Casa
                                                                    </label>
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="radio"
                                                                            className="form-control"
                                                                            id="typeApartamento"
                                                                            name="type"
                                                                            value="apartamento"
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .type ===
                                                                                'apartamento'
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Apartamento
                                                                    </label>
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="radio"
                                                                            className="form-control"
                                                                            id="typeNegocio"
                                                                            name="type"
                                                                            value="negocio"
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .type ===
                                                                                'negocio'
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Negocio
                                                                    </label>
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="radio"
                                                                            className="form-control"
                                                                            id="typeOther"
                                                                            name="type"
                                                                            value="otro"
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .type === 'otro'
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Otro
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <hr />
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="checkbox"
                                                                            className="form-control"
                                                                            id="coolingDispenser"
                                                                            name="coolingDispenser"
                                                                            value={true}
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .coolingDispenser
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Dispensador vertical
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="checkbox"
                                                                            className="form-control"
                                                                            id="publicSite"
                                                                            name="publicSite"
                                                                            value={true}
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .publicSite
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Sitio público
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="checkbox"
                                                                            className="form-control"
                                                                            id="longway"
                                                                            name="longway"
                                                                            value={true}
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .longway
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Dirección larga
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="checkbox"
                                                                            className="form-control"
                                                                            id="newBottleAguaman"
                                                                            name="newBottleAguaman"
                                                                            value={true}
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .newBottleAguaman
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        Botellón nuevo de aguaman
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        <input
                                                                            style={{
                                                                                width: 30,
                                                                                display: 'inline',
                                                                            }}
                                                                            type="checkbox"
                                                                            className="form-control"
                                                                            id="gpsVerified"
                                                                            name="gpsVerified"
                                                                            value={true}
                                                                            defaultChecked={
                                                                                modalAddress.data &&
                                                                                modalAddress.data
                                                                                    .gpsVerified
                                                                            }
                                                                            ref={register({
                                                                                required: false,
                                                                            })}
                                                                        />
                                                                        GPS Verificado
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label htmlFor="photoBottle">
                                                                        Foto del envase
                                                                    </label>
                                                                    <input
                                                                        className="form-control upload"
                                                                        type="file"
                                                                        name="photoBottle"
                                                                        id="photoBottle"
                                                                        accept="image/*"
                                                                        onChange={handleInputImage}
                                                                        ref={register({
                                                                            required: false,
                                                                        })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            {modalAddress.data &&
                                                                modalAddress.data.photoBottle && (
                                                                    <div className="form-group mb-4 row">
                                                                        <div className="col-xl-12">
                                                                            <button
                                                                                className="btn btn-danger"
                                                                                onClick={() =>
                                                                                    deletePhotoBottle(
                                                                                        modalAddress.data,
                                                                                    )
                                                                                }
                                                                            >
                                                                                Eliminar foto
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-12">
                                                                    <div
                                                                        style={{
                                                                            width: '100%',
                                                                            height: 300,
                                                                        }}
                                                                        id="map"
                                                                    />
                                                                    {errors.location &&
                                                                        errors.location.type === 'required' && (
                                                                            <p className="message-error-input">
                                                                                Ubicación GPS es obligatoria
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={handleSubmit(
                                                    modalAddress.data
                                                        ? updateClientLocation
                                                        : addClientLocation,
                                                )}
                                            >
                                                {modalAddress.data ? 'Modificar' : 'Guardar'}{' '}
                                                dirección
                                            </button>
                                        </div>
                                    </Modal>
                                    {/* Modal de suscripción */}
                                    {client.purchases.length > 0 && (
                                        <ModalSubscription
                                            open={modalSubscription.visible}
                                            onClose={() => setModalSubscription({ visible: false })}
                                            franchiseId={client.purchases[0].franchise.id}
                                            clientId={client.id}
                                        />
                                    )}
                                    {/* Modal de correo */}
                                    <Modal
                                        open={modalCorreo}
                                        center
                                        style={{ width: 700 }}
                                        onClose={() => setModalCorreo(false)}
                                    >
                                        <div className="modal-header">
                                            <h5 className="modal-title f-w-600">
                                                Enviar correo de recuperar contraseña
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <p>
                                                ¿Está seguro de enviar un correo electrónico al
                                                cliente para recuperar su contraseña?{' '}
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => sendEmailClientOffline(client.email)}
                                            >
                                                Enviar correo
                                            </button>
                                        </div>
                                    </Modal>
                                    {/* Modal de información fiscal */}
                                    <Modal
                                        open={modalLegalInformation}
                                        center
                                        classNames={{ modal: 'modal-update-address' }}
                                        onClose={() => setModalLegalInformation(false)}
                                    >
                                        <div className="modal-header">
                                            <h5 className="modal-title f-w-600">
                                                Información fiscal
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row product-adding">
                                                <div className="col-xl-10 offset-xl-1">
                                                    <div className="needs-validation add-product-form">
                                                        <div className="form form-label-center">
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>Razón social</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="businessName"
                                                                        placeholder="Nombre de la empresa"
                                                                        defaultValue={
                                                                            client.legalInformation &&
                                                                            client.legalInformation
                                                                                .businessName
                                                                        }
                                                                        ref={registerLegal({
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                    {errorsLegal.businessName &&
                                                                        errorsLegal.businessName
                                                                            .type ===
                                                                        'required' && (
                                                                            <p className="message-error-input">
                                                                                Razón social
                                                                                obligatoria
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>RIF</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="rif"
                                                                        placeholder="J-20608546-7"
                                                                        defaultValue={
                                                                            client.legalInformation &&
                                                                            client.legalInformation
                                                                                .rif
                                                                        }
                                                                        ref={registerLegal({
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                    {errorsLegal.rif &&
                                                                        errorsLegal.rif.type ===
                                                                        'required' && (
                                                                            <p className="message-error-input">
                                                                                RIF obligatorio
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>
                                                                        Número de teléfono
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="legalPhoneNumber"
                                                                        placeholder="0414-7353821"
                                                                        defaultValue={
                                                                            client.legalInformation &&
                                                                            client.legalInformation
                                                                                .phoneNumber
                                                                        }
                                                                        ref={registerLegal({
                                                                            required: true,
                                                                        })}
                                                                    />
                                                                    {errorsLegal.legalPhoneNumber &&
                                                                        errorsLegal.legalPhoneNumber
                                                                            .type ===
                                                                        'required' && (
                                                                            <p className="message-error-input">
                                                                                Teléfono obligatorio
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-4 row">
                                                                <div className="col-xl-12">
                                                                    <label>Dirección fiscal</label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        rows="3"
                                                                        name="legalAddress"
                                                                        defaultValue={
                                                                            client.legalInformation &&
                                                                            client.legalInformation
                                                                                .address
                                                                        }
                                                                        ref={registerLegal({
                                                                            required: false,
                                                                        })}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={handleSubmitLegal(updateLegalInformation)}
                                            >
                                                Guardar
                                            </button>
                                        </div>
                                    </Modal>
                                    <Modal
                                        open={modalDeleteAddress.visible}
                                        center
                                        style={{ width: 700 }}
                                        onClose={() => setModalDeleteAddress({ visible: false })}
                                    >
                                        <div className="modal-header">
                                            <h5 className="modal-title f-w-600">
                                                Eliminar dirección
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <p>¿Está seguro de eliminar esta dirección? </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() =>
                                                    deleteAddress(modalDeleteAddress.data)
                                                }
                                            >
                                                Sí
                                            </button>
                                        </div>
                                    </Modal>
                                    <Modal
                                        open={modalDefaultAddress.visible}
                                        center
                                        style={{ width: 700 }}
                                        onClose={() => setModalDefaultAddress({ visible: false })}
                                    >
                                        <div className="modal-header">
                                            <h5 className="modal-title f-w-600">
                                                Dirección por defecto
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <p>
                                                ¿Está seguro de dejar esta dirección por
                                                defecto?{' '}
                                            </p>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() =>
                                                    defaultAddress(modalDefaultAddress.data)
                                                }
                                            >
                                                Sí
                                            </button>
                                        </div>
                                    </Modal>
                                </div>
                            </div>
                        </div>
                        {client.expoToken && (
                            <div className="card">
                                <div className="card-body">
                                    <form
                                        onSubmit={handleSubmitPush(sendPushNotification)}
                                        className="needs-validation user-add"
                                        noValidate=""
                                    >
                                        <h4>Enviar notificación push</h4>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Título
                                            </label>
                                            <input
                                                className="form-control col-xl-3 col-md-7"
                                                type="text"
                                                name="title"
                                                ref={registerPush({
                                                    required: true,
                                                })}
                                            />
                                            <p className="message-error-input">
                                                {errorsPush.title &&
                                                    errorsPush.title.type === 'required' &&
                                                    'Titulo obligatorio'}
                                            </p>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Mensaje
                                            </label>
                                            <input
                                                className="form-control col-xl-5 col-md-7"
                                                type="text"
                                                name="body"
                                                ref={registerPush({
                                                    required: true,
                                                })}
                                            />
                                            <p className="message-error-input">
                                                {errorsPush.body &&
                                                    errorsPush.body.type === 'required' &&
                                                    'Mensaje obligatorio'}
                                            </p>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span></span> Vista
                                            </label>
                                            <input
                                                className="form-control col-xl-3 col-md-7"
                                                placeholder="RecargarBotellon o DetailOrder"
                                                type="text"
                                                name="view"
                                                ref={registerPush({
                                                    required: false,
                                                })}
                                            />
                                            <label className="col-xl-1 col-md-4">
                                                <span></span> ID Vista
                                            </label>
                                            <input
                                                className="form-control col-xl-2 col-md-7"
                                                placeholder="Necesario para un detalle de orden"
                                                type="text"
                                                name="viewId"
                                                ref={registerPush({
                                                    required: false,
                                                })}
                                            />
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span></span> Link
                                            </label>
                                            <input
                                                className="form-control col-xl-5 col-md-7"
                                                placeholder="https://www.instagram.com/p/CNqYSqwhSMs/"
                                                type="text"
                                                name="link"
                                                ref={registerPush({
                                                    required: false,
                                                })}
                                            />
                                        </div>
                                        <div className="col-sm-12 text-center mt-5 mb-3">
                                            <button
                                                type="submit"
                                                className="btn btn-success"
                                                onClick={handleSubmitPush(sendPushNotification)}
                                            >
                                                Enviar notificación
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )}
                        <div className="card">
                            <div className="card-body">
                                <div className="needs-validation user-add">
                                    <h4>Historial de Pedidos</h4>
                                    <div>
                                        {client.purchases.length > 0
                                            ? renderClientPurchases()
                                            : 'Este cliente no ha realizado ningún pedido'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
});

export default ClientDetail;
